import { postCustomerCompany } from "@erp/shared/api/generated/wrappers/customer";
import { patchCustomerCompany } from "@erp/shared/api/generated/wrappers/customer";
import { deleteCustomerCompany } from "@erp/shared/api/generated/wrappers/customer";
import { getCustomerPersons } from "@erp/shared/api/generated/wrappers/customer";
import { postCustomerPerson } from "@erp/shared/api/generated/wrappers/customer";
import { patchCustomerPerson } from "@erp/shared/api/generated/wrappers/customer";
import { deleteCustomerPerson } from "@erp/shared/api/generated/wrappers/customer";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
export const useCustomerManagementAction = (selectedCompanyId) => {
    const { invalidateQueries } = useInvalidateQueries();
    // 거래처 목록 조회
    const readCompaniesQuery = useQuery(queries.customerCompany.list());
    // 담당자 목록 조회 (선택된 거래처가 있을 때만)
    const readPersonsQueryOptions = computed(() => {
        const companyId = selectedCompanyId.value ?? 0;
        return {
            ...queries.customerPerson.byCompany(companyId),
            queryFn: () => getCustomerPersons(companyId),
            enabled: selectedCompanyId.value !== null,
        };
    });
    const readPersonsQuery = useQuery(readPersonsQueryOptions);
    // 거래처 생성
    const createCompanyMutation = useMutation({
        mutationFn: (body) => postCustomerCompany(body),
        onSuccess: () => {
            showAlert("거래처 등록 완료", "완료");
            invalidateQueries([queries.customerCompany.list().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "거래처 등록 실패");
        },
    });
    // 거래처 수정
    const updateCompanyMutation = useMutation({
        mutationFn: ({ id, body }) => patchCustomerCompany(id, body),
        onSuccess: () => {
            showAlert("거래처 수정 완료", "완료");
            invalidateQueries([queries.customerCompany.list().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "거래처 수정 실패");
        },
    });
    // 거래처 삭제
    const deleteCompanyMutation = useMutation({
        mutationFn: (id) => deleteCustomerCompany(id),
        onSuccess: () => {
            showAlert("거래처 삭제 완료", "완료");
            invalidateQueries([queries.customerCompany.list().queryKey]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "거래처 삭제 실패");
        },
    });
    // 담당자 생성
    const createPersonMutation = useMutation({
        mutationFn: (body) => postCustomerPerson(body),
        onSuccess: () => {
            showAlert("담당자 등록 완료", "완료");
            if (selectedCompanyId.value) {
                invalidateQueries([
                    queries.customerPerson.byCompany(selectedCompanyId.value).queryKey,
                ]);
            }
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "담당자 등록 실패");
        },
    });
    // 담당자 수정
    const updatePersonMutation = useMutation({
        mutationFn: ({ id, body, }) => patchCustomerPerson(id, body),
        onSuccess: () => {
            showAlert("담당자 수정 완료", "완료");
            if (selectedCompanyId.value) {
                invalidateQueries([
                    queries.customerPerson.byCompany(selectedCompanyId.value).queryKey,
                ]);
            }
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "담당자 수정 실패");
        },
    });
    // 담당자 삭제
    const deletePersonMutation = useMutation({
        mutationFn: (id) => deleteCustomerPerson(id),
        onSuccess: () => {
            showAlert("담당자 삭제 완료", "완료");
            if (selectedCompanyId.value) {
                invalidateQueries([
                    queries.customerPerson.byCompany(selectedCompanyId.value).queryKey,
                ]);
            }
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "담당자 삭제 실패");
        },
    });
    return {
        readCompaniesQuery,
        readPersonsQuery,
        createCompanyMutation,
        updateCompanyMutation,
        deleteCompanyMutation,
        createPersonMutation,
        updatePersonMutation,
        deletePersonMutation,
    };
};
